import Vue from "vue";

export const EVENTS = {
    UPDATE_NOTIFICATION_LIST: "update:notification_list",
    DELETE_NOTIFICATION_LIST: "delete:notification_list",
    UPDATE_IS_DIRTY: "update:is_dirty"
};

export const EventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/notifcation-lists/EventBus.js